
<div class="row features">
  <article id="content"> 
    <header>
      <h2>Darcy Wronkiewicz, IBCLC, CD(DONA)</h2>
    </header>
    <img class="image right" width="30%" src="assets/images/darcy_1.jpg" alt="" />
    <p>Darcy Wronkiewicz approaches mother-baby work from her perspective as both a mother, and a multi-certified birth and lactation professional. Darcy earned her CLC in 2008, and became a certified doula through DONA in 2011. In 2015 she completed her coursework and passed her exam to become an International Board Certified Lactation Consultant.  She currently works as a birth educator, doula, and lactation consultant - providing a spectrum of education and care to families from conception, to birth, to the “fourth trimester,” and beyond.</p>
    <p>One of Darcy’s favorite aspects of working with expecting parents is helping them formulate a plan for birth and feeding that provides guidelines for a variety of scenarios, while always centering the family’s values and priorities.  She also loves the role she plays in supporting mother-newborn dyads through the first months of breastfeeding, and seeing parents gain both evidence-based knowledge, and a strong intuitive sense of what Baby needs.</p>
    <p>Darcy holds a BS in Computer Science and Engineering and spent 15 years working in the embedded development tools space.  She lives in Ventura, with her husband and three school-aged children. They are doing okay.</p>
  </article>
</div>
<!--<div class="row features">
        <section class="col-4 col-12-narrower feature">
          <div class="image-wrapper first"> <a href="#" class="image featured"><img src="assets/images/pic03.jpg" alt="" /></a> </div>
          <header>
            <h3>Dolor sit consequat magna</h3>
          </header>
          <p>Lorem ipsum dolor sit amet consectetur et sed adipiscing elit. Curabitur
            vel sem sit dolor neque semper magna lorem ipsum.</p>
          <ul class="actions">
            <li><a href="#" class="button">Elevate my awareness</a></li>
          </ul>
        </section>
        <section class="col-4 col-12-narrower feature">
          <div class="image-wrapper"> <a href="#" class="image featured"><img src="assets/images/pic04.jpg" alt="" /></a> </div>
          <header>
            <h3>Dolor sit consequat magna</h3>
          </header>
          <p>Lorem ipsum dolor sit amet consectetur et sed adipiscing elit. Curabitur
            vel sem sit dolor neque semper magna lorem ipsum.</p>
          <ul class="actions">
            <li><a href="#" class="button">Elevate my awareness</a></li>
          </ul>
        </section>
        <section class="col-4 col-12-narrower feature">
          <div class="image-wrapper"> <a href="#" class="image featured"><img src="assets/images/pic05.jpg" alt="" /></a> </div>
          <header>
            <h3>Dolor sit consequat magna</h3>
          </header>
          <p>Lorem ipsum dolor sit amet consectetur et sed adipiscing elit. Curabitur
            vel sem sit dolor neque semper magna lorem ipsum.</p>
          <ul class="actions">
            <li><a href="#" class="button">Elevate my awareness</a></li>
          </ul>
        </section>
      </div>--> 
